/*
    global createMojeidConnect
*/

function parseClaims(clientClaims) {
    const claims = {}
    for (const name in clientClaims) {
        claims[name] = {'essential': clientClaims[name][1]}
    }
    return claims
}

function fillForm(uiDict) {
    const address_keys = [
        'mojeid_address_def',
        'mojeid_address_bill',
        'mojeid_address_ship',
        'mojeid_address_ship2',
        'mojeid_address_ship3',
    ]
    for (const key in uiDict) {
        if (this.claims[key]) {
            const field_name = this.claims[key][0]
            const nodes = document.querySelectorAll(
                'input[name=' + field_name + '], ' +
                'select[name=' + field_name + '], ' +
                'textarea[name=' + field_name + ']',
            )
            if (nodes.length) {
                // Temporary fix until #26134 is done.
                // Class IdToken on https://github.com/OpenIDC/pyoidc/blob/master/src/oic/oic/message.py#L704-L705
                // has only attributes OpenIDSchema which causes the MojeID addresses are in json instead of being
                // parsed to the object.
                if (address_keys.includes(key) && typeof(uiDict[key]) !== 'object') {
                    this.setValueToElements(nodes, this.decodeValue(JSON.parse(uiDict[key])))
                } else {
                    this.setValueToElements(nodes, this.decodeValue(uiDict[key]))
                }
            }
        }
    }
}

function initPrefill() {
    const signin_form_node = document.getElementById('signin-form')
    const mojeID = createMojeidConnect({
        clientIdName: signin_form_node.dataset.client_name,
        clientName: signin_form_node.dataset.client_name,
        claims: JSON.parse(signin_form_node.dataset.fields),
        parseClaimsCallback: parseClaims,
        formCallback: fillForm,
        registerClientManualy: true,
        registrationSuccessCallback: () => {
            document.getElementById('signin-form').classList.remove('invisible')
        },
    })
    document.querySelector('#signin-form .mojeid-button').addEventListener(
        'click', mojeID.requestAuthentication.bind(mojeID))

    mojeID.callbacks['formCallback'].call(mojeID, mojeID.parseToken())
    mojeID.registerClient()
}

document.addEventListener('DOMContentLoaded', initPrefill)
